import { createWidget } from '@alfa-bank/site-util-create-widget';
import { validateNotEmpty } from '@alfa-bank/site-form-helpers/validation/not-empty';
import { Fields } from '@alfa-bank/site-form-utils/components/multi-field';
import type { TFio, IDeps } from '@alfa-bank/site-form-fio/src/models';
// eslint-disable-next-line regex/invalid
import { Fio as Component } from '@alfa-bank/site-form-fio/src/fio';

import { FioField } from '../fio-field';

export const FioDesktop = createWidget<IDeps, TFio>({
    Fields,
    FioField,
    validateNotEmpty,
})(Component);
